// * -------------------------------- NPM --------------------------------------
import React from 'react'

// * -------------------------------- MODULE --------------------------------------
import Flex from '../MVFlex/Flex'
import Title from '../MVText/Title'
import { ButtonVariants } from '../MVButtons/types'
import { LinkButton } from '../MVButtons/Button'
import { IsLoading } from '../../../mvtypes/base'

interface BackTitleProps extends IsLoading {
  title: string
}

const BackTitle = (props: BackTitleProps) => {
  // * ----------------------------------------------------------------------------------------
  // * -------------------------------- RENDERs --------------------------------------
  // * ----------------------------------------------------------------------------------------
  return (
    <Flex>
      <LinkButton
        icon={'chevron-left'}
        semantic={'secondary'}
        variant={ButtonVariants.flat}
        to={location => {
          const path = location.pathname.replace(location.pathname.substring(location.pathname.lastIndexOf('/')), '')
          return { ...location, pathname: path }
        }}
      />
      <Title level={1} title={props.title} isLoading={props.isLoading} />
    </Flex>
  )
}

export default BackTitle
